export enum StartDates {
   Current_Day = 'T',
   Next_Day = 'T+1D',
   Second_Day = 'T+2D',
   Third_Day = 'T+3D',
   Fourth_Day = 'T+4D',

   Monday    = 'T~+D1',
   Tuesday   = 'T~+D2',
   Wednesday = 'T~+D3',
   Thursday  = 'T~+D4',
   Friday    = 'T~+D5',
   Saturday  = 'T~+D6',
   Sunday    = 'T~+D0',
}

export const DateLimit = 30; // Days
